import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiHttpService } from '../ApiHttpService/apiHttp.service';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CommonService {

  constructor(private api: ApiHttpService) { }

  private API_URL = environment.PathAPI
  GetNotification(reqData: any): Observable<any> {
    const url: string = `${this.API_URL}Notification/GetInsurerNotification/`+ reqData;
    return this.api.get(url)
  };

  GetFileUrlByUniqueDocId(reqData: any): Observable<any> {
    const headers = { "Content-Type": "application/json; charset=utf-8" }
    const url: string = this.API_URL + "Claim/GetFileUrlByUniqueDocId";
    return this.api.post(url, JSON.stringify(reqData), { 'headers': headers })
  }

}
